import { CheckCircle, MessageSquare, Sparkles, Shield } from "lucide-react";

const usps = [
  {
    icon: Sparkles,
    title: "Saubere Arbeit",
    description: "Wir hinterlassen jede Baustelle besenrein und arbeiten präzise bis ins Detail."
  },
  {
    icon: Shield,
    title: "Zuverlässige Umsetzung",
    description: "Termingerecht, budgettreu und ohne böse Überraschungen."
  },
  {
    icon: MessageSquare,
    title: "Direkte Kommunikation",
    description: "Persönlicher Ansprechpartner, erreichbar per Telefon und WhatsApp."
  },
  {
    icon: CheckCircle,
    title: "Hochwertige Materialien",
    description: "Wir verwenden nur geprüfe Markenprodukte für langlebige Ergebnisse."
  }
];

const WhyUs = () => {
  return (
    <section className="py-16 sm:py-20 bg-[#4A331D]" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-14">
          <h2
            className="text-3xl sm:text-4xl font-bold text-white mb-3"
            style={{ fontFamily: "Work Sans, sans-serif" }}
          >
            Warum Kunden BEKAJ BAU wählen
          </h2>
          <p className="text-[#D4AA6A] text-base sm:text-lg">
            Qualität, die man sieht und spürt.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {usps.map((usp, idx) => {
            const Icon = usp.icon;
            return (
              <div
                key={idx}
                className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 text-center hover:bg-white/15 transition-colors"
                data-testid={`usp-card-${idx}`}
              >
                <div className="w-14 h-14 bg-[#D4AA6A] rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-7 h-7 text-[#4A331D]" />
                </div>
                <h3 className="text-lg font-bold text-white mb-2">{usp.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed">{usp.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
